export { IconLabel } from "./IconLabel";
